// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const ARCHIVE_BASE_URL = '/api/v1/wechat/archive';

/**
 * 获取文书档案列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getArchiveList(
  params?: OA.ArchiveListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchiveListData>>(
    `${ARCHIVE_BASE_URL}`,
    {
      method: 'GET',
      params: params || {},
      ...(options || {}),
    },
  );
}

/**
 * 获取文书档案详情
 * @param archive_id 档案ID
 * @param options 请求配置
 */
export async function getArchiveDetail(
  archive_id: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchiveRecord>>(
    `${ARCHIVE_BASE_URL}/${archive_id}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 创建文书档案
 * @param data 创建参数
 * @param options 请求配置
 */
export async function createArchive(
  data: OA.CreateArchiveParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchiveRecord>>(
    `${ARCHIVE_BASE_URL}`,
    {
      method: 'POST',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 更新文书档案
 * @param archive_id 档案ID
 * @param data 更新参数
 * @param options 请求配置
 */
export async function updateArchive(
  archive_id: number,
  data: OA.UpdateArchiveParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchiveRecord>>(
    `${ARCHIVE_BASE_URL}/${archive_id}`,
    {
      method: 'PUT',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 删除文书档案
 * @param archive_id 档案ID
 * @param options 请求配置
 */
export async function deleteArchive(
  archive_id: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.MessageResponse>>(
    `${ARCHIVE_BASE_URL}/${archive_id}`,
    {
      method: 'DELETE',
      ...(options || {}),
    },
  );
}

/**
 * 添加档案文件
 * @param archive_id 档案ID
 * @param data 文件信息
 * @param options 请求配置
 */
export async function addArchiveFile(
  archive_id: number,
  data: OA.AddArchiveFileParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchiveFile>>(
    `${ARCHIVE_BASE_URL}/${archive_id}/files`,
    {
      method: 'POST',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 删除档案文件
 * @param archive_id 档案ID
 * @param file_id 文件ID
 * @param options 请求配置
 */
export async function deleteArchiveFile(
  archive_id: number,
  file_id: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.MessageResponse>>(
    `${ARCHIVE_BASE_URL}/${archive_id}/files/${file_id}`,
    {
      method: 'DELETE',
      ...(options || {}),
    },
  );
}

/**
 * 编辑档案文件
 * @param archive_id 档案ID
 * @param file_id 文件ID
 * @param data 编辑参数
 * @param options 请求配置
 */
export async function updateArchiveFile(
  archive_id: number,
  file_id: number,
  data: OA.UpdateArchiveFileParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchiveFile>>(
    `${ARCHIVE_BASE_URL}/${archive_id}/files/${file_id}`,
    {
      method: 'PUT',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 提交纸质材料
 * @param archive_id 档案ID
 * @param options 请求配置
 */
export async function submitPaperMaterial(
  archive_id: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.MessageResponse>>(
    `${ARCHIVE_BASE_URL}/${archive_id}/submit-paper`,
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}

/**
 * 确认收取纸质材料
 * @param archive_id 档案ID
 * @param options 请求配置
 */
export async function confirmPaperMaterial(
  archive_id: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.MessageResponse>>(
    `${ARCHIVE_BASE_URL}/${archive_id}/confirm-paper`,
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}

/**
 * 获取文书档案管理员列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getArchiveAdminList(
  params?: OA.ArchiveAdminListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchiveAdmin[]>>(
    `${ARCHIVE_BASE_URL}/admins`,
    {
      method: 'GET',
      params: params || {},
      ...(options || {}),
    },
  );
}

/**
 * 添加文书档案管理员
 * @param data 管理员信息
 * @param options 请求配置
 */
export async function addArchiveAdmin(
  data: OA.AddArchiveAdminParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchiveAdmin>>(
    `${ARCHIVE_BASE_URL}/admins`,
    {
      method: 'POST',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 移除文书档案管理员
 * @param admin_id 管理员ID
 * @param options 请求配置
 */
export async function removeArchiveAdmin(
  admin_id: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.MessageResponse>>(
    `${ARCHIVE_BASE_URL}/admins/${admin_id}`,
    {
      method: 'DELETE',
      ...(options || {}),
    },
  );
}

/**
 * 更新文书档案管理员
 * @param admin_id 管理员ID
 * @param data 更新参数
 * @param options 请求配置
 */
export async function updateArchiveAdmin(
  admin_id: number,
  data: OA.UpdateArchiveAdminParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchiveAdmin>>(
    `${ARCHIVE_BASE_URL}/admins/${admin_id}`,
    {
      method: 'PUT',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 获取当前用户的文书档案权限
 * @param options 请求配置
 */
export async function getArchivePermissions(
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchivePermissions>>(
    `${ARCHIVE_BASE_URL}/my-permissions`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

// ==================== 部门档案前缀配置 ====================

/**
 * 获取部门档案前缀配置列表
 * @param options 请求配置
 */
export async function getArchivePrefixConfigList(
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchivePrefixConfig[]>>(
    `${ARCHIVE_BASE_URL}/number-config/prefixes`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 创建部门档案前缀配置
 * @param data 配置参数
 * @param options 请求配置
 */
export async function createArchivePrefixConfig(
  data: OA.CreateArchivePrefixConfigParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchivePrefixConfig>>(
    `${ARCHIVE_BASE_URL}/number-config/prefixes`,
    {
      method: 'POST',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 更新部门档案前缀配置
 * @param config_id 配置ID
 * @param data 配置参数
 * @param options 请求配置
 */
export async function updateArchivePrefixConfig(
  config_id: number,
  data: OA.UpdateArchivePrefixConfigParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchivePrefixConfig>>(
    `${ARCHIVE_BASE_URL}/number-config/prefixes/${config_id}`,
    {
      method: 'PUT',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 删除部门档案前缀配置
 * @param config_id 配置ID
 * @param options 请求配置
 */
export async function deleteArchivePrefixConfig(
  config_id: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(
    `${ARCHIVE_BASE_URL}/number-config/prefixes/${config_id}`,
    {
      method: 'DELETE',
      ...(options || {}),
    },
  );
}

// ==================== 档案编号序列配置 ====================

/**
 * 获取档案编号序列配置列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getArchiveNumberConfig(
  params?: OA.GetArchiveNumberConfigParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchiveNumberConfig[]>>(
    `${ARCHIVE_BASE_URL}/number-config`,
    {
      method: 'GET',
      params: params || {},
      ...(options || {}),
    },
  );
}

/**
 * 更新档案编号序列值
 * @param config_id 配置ID
 * @param data 配置参数
 * @param options 请求配置
 */
export async function updateArchiveNumberConfig(
  config_id: number,
  data: OA.UpdateArchiveNumberConfigParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ArchiveNumberConfig>>(
    `${ARCHIVE_BASE_URL}/number-config/${config_id}`,
    {
      method: 'PUT',
      data,
      ...(options || {}),
    },
  );
}

